module.exports = __webpack_public_path__ + "img/loca_classic_pconly.76308b96.png";